module.exports = __webpack_public_path__ + "static/spaghetti-a250e6cde8e5277883666f1852a2429e.jpg";